import { Component, Input, Output, forwardRef, Renderer2, ElementRef, ViewChild, EventEmitter, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import { PrimeNGConfig } from 'primeng/api';
import { Calendar } from 'primeng/calendar';

import { OnNativeFocus } from 'src/app/shared/utils/form';
import { Moment } from 'src/app/shared/utils';

export interface DateTypes {
  date: any;
}

@Component({
  selector: 'app-datepicker',
  template: `<p-calendar #calendar [ngModel]="value" (ngModelChange)="valueChange($event)"
                  [disabled]="_disabled" showButtonBar="true" [inputStyleClass]="inputClass"
                  dateFormat="dd/mm/yy" [showTime]="showTime" [showIcon]="showIcon" [timeOnly]=timeOnly
                  [tabindex]="tabindex" [hourFormat]="hourFormat" [readonlyInput]="readOnly">
                </p-calendar>`,
  // styles: [':host { .p-inputtext { border: none; width: 30px !important; } }'],
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => DatepickerComponent), multi: true },
  ]
})
export class DatepickerComponent implements ControlValueAccessor, OnNativeFocus, OnInit {
  @ViewChild('calendar') calendar: Calendar;
  @Input() format = 'YYYY-MM-DD';
  @Input() maxNow = false;
  @Input() clear = true;
  @Input() readOnly = true;
  @Input() timeOnly = false;
  @Input() inputClass = 'form-control';
  @Input() showTime: boolean;
  @Input() showIcon: boolean;
  @Input() hourFormat: string;
  @Input() tabindex: number;
  // tslint:disable-next-line: no-output-on-prefix
  @Output() onSelect = new EventEmitter();

  public value: any;
  public _disabled = false;
  private onChangeCallback: (_: any) => void = () => { };
  private onTouchedCallback: () => void = () => { };

  constructor(
    private renderer2: Renderer2,
    private ref: ElementRef,
    private primengConfig: PrimeNGConfig,
  ) { }

  ngOnInit() {
    // Configurar as traduções diretamente para o PrimeNG
    this.primengConfig.setTranslation({
      firstDayOfWeek: 0,
      dayNames: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
      dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
      dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
      monthNames: [
        'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
        'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
      ],
      monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
      today: 'Hoje',
      clear: 'Limpar',
      accept: 'Aceitar',
      weekHeader: 'Sem'
    });
  }

  public focus(): void {
    if (this.calendar && this.calendar.el && this.calendar.el.nativeElement) {
      this.calendar.showOverlay();
    }
  }

  @Input('disabled')
  set disabled(value: boolean) {
    this.setDisabledState(value);
  }

  public setDisabledState(isDisabled: boolean): void {
    this._disabled = isDisabled;
  }

  public registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }

  public writeValue(value: any): void {
    if (value) {
      let mDate = Moment(this.format === 'ecm' ? value.date : value);

      if (value && (!mDate || !mDate.isValid())) {
        mDate = Moment(value, [this.format]);
      }

      if (mDate && mDate.isValid()) {
        this.value = mDate.toDate();
        return;
      }
    }

    this.value = null;
  }

  public valueChange(date: Date): void {
    let value = null;
    if (!!date) {
      const mDate = Moment(date);
      if (!mDate.isValid()) { return; }

      if (this.format === 'ecm') {
        value = { date: mDate.format() };
      } else if (!!this.format) {
        value = mDate.format(this.format);
      } else {
        value = mDate.format();
      }
    }

    try {
      this.onChangeCallback(value);
      this.onSelect.emit(value);
    } catch (e) { }
  }
}
